module.exports = __webpack_public_path__ + "media/music/synth_chords_3-437b09cb.mp3";